import type { FuseResult } from 'fuse.js';
import type { CommandInternal } from '../../../../common/types/commands/index.tsx';

export const filterCommandsFromSearch = (
	search: string,
	fuseResults: FuseResult<CommandInternal>[],
	commands: CommandInternal[],
): CommandInternal[] => {
	const trimmedSearch = search.trim().toLowerCase();
	if (!trimmedSearch.length)
		return commands.map((command) => ({ ...command, searchRelevancyScore: 1 }));

	return commands.flatMap((command) => {
		const fuseResult = fuseResults.find((result) => result.item.id === command.id);
		if (fuseResult) {
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			return [{ ...command, searchRelevancyScore: fuseResult.score as number }]; // includeScore is true, will always return a number
		}

		return [];
	});
};
